import { render, staticRenderFns } from "./packageQuan.vue?vue&type=template&id=5d985bdc&scoped=true"
import script from "./packageQuan.vue?vue&type=script&lang=js"
export * from "./packageQuan.vue?vue&type=script&lang=js"
import style0 from "./packageQuan.vue?vue&type=style&index=0&id=5d985bdc&prod&lang=scss"
import style1 from "./packageQuan.vue?vue&type=style&index=1&id=5d985bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d985bdc",
  null
  
)

export default component.exports